function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useState, useContext } from "react";
import ChevronRightIcon from "../../Icon/ChevronRight";
import ChevronLeftIcon from "../../Icon/ChevronLeft";
import SearchIcon from "../../Icon/Search";
import { buildTestIdProp } from "@cvent/nucleus-test-automation";
import { Tooltip } from "../../Tooltip";
import Button from "../../Button";
import useStyle from "./Search.style";
import { SearchContainer } from "./SearchContainer";
import OnWhen from "../../OnWhen";
import { useBreakpoints } from "../../Breakpoints/BreakpointsProvider";
import { FlagsContext } from "../../FlagsProvider";
import { POPPER_ZINDEX } from "../../ZIndexProvider";
export var Search = function(param) {
    var accessibilityLabel = param.accessibilityLabel, children = param.children, clearSearchTerm = param.clearSearchTerm, clearButtonAccessibilityLabel = param.clearButtonAccessibilityLabel, openFlyoutAccessibilityLabel = param.openFlyoutAccessibilityLabel, onSearch = param.onSearch, onChange = param.onChange, isSearchOpen = param.isSearchOpen, setIsSearchOpen = param.setIsSearchOpen, searchInputAccessibilityLabel = param.searchInputAccessibilityLabel, searchTerm = param.searchTerm, inputRef = param.inputRef, isRtl = param.isRtl, testID = param.testID;
    var breakpoints = useBreakpoints();
    var ref3 = _slicedToArray(useState(false), 2), isFiltersOpen = ref3[0], setIsFiltersOpen = ref3[1];
    var ref1;
    var zIndexUpdates = ((ref1 = useContext(FlagsContext)) !== null && ref1 !== void 0 ? ref1 : {}).zIndexUpdates;
    var zIndex = zIndexUpdates ? POPPER_ZINDEX : 400;
    var ref2 = useStyle({
        isRtl: isRtl,
        breakpoints: breakpoints,
        isSearchOpen: isSearchOpen,
        zIndex: zIndex
    }), searchContainerStyles = ref2.searchContainerStyles, searchSubContainerStyles = ref2.searchSubContainerStyles, smallScreenSearchButtonStyles = ref2.smallScreenSearchButtonStyles, filtersContainerStyles = ref2.filtersContainerStyles;
    return _jsxs("div", {
        css: searchContainerStyles,
        children: [
            _jsx(Tooltip, {
                text: accessibilityLabel,
                placement: "bottom",
                portal: true,
                trigger: function(openTooltip, closeTooltip, forwardedRef) {
                    return _jsx(Button, {
                        forwardedRef: forwardedRef,
                        testID: testID,
                        icon: SearchIcon,
                        appearance: "ghost",
                        variant: "neutral-black",
                        isPill: true,
                        disabled: isSearchOpen,
                        onClick: function() {
                            setIsSearchOpen(true);
                            if (!isSearchOpen) {
                                closeTooltip();
                            }
                            setTimeout(function() {
                                var ref;
                                return inputRef === null || inputRef === void 0 ? void 0 : (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                            }, 1);
                        },
                        onMouseEnter: !isSearchOpen ? openTooltip : undefined,
                        onMouseLeave: !isSearchOpen ? closeTooltip : undefined,
                        onFocus: !isSearchOpen ? openTooltip : undefined,
                        onBlur: !isSearchOpen ? closeTooltip : undefined,
                        "aria-label": accessibilityLabel,
                        "aria-expanded": isSearchOpen
                    });
                }
            }),
            isSearchOpen && _jsxs("div", {
                css: searchSubContainerStyles,
                children: [
                    _jsx(OnWhen, {
                        s: true,
                        defaultSize: true,
                        children: _jsx("div", {
                            css: smallScreenSearchButtonStyles,
                            children: _jsx(Button, _objectSpread({}, buildTestIdProp([
                                testID,
                                'close'
                            ]), {
                                icon: isRtl ? ChevronRightIcon : ChevronLeftIcon,
                                appearance: "ghost",
                                variant: "neutral-black",
                                isPill: true,
                                onClick: function() {
                                    return setIsSearchOpen(false);
                                }
                            }))
                        })
                    }),
                    _jsx(SearchContainer, {
                        clearSearchTerm: clearSearchTerm,
                        onChange: onChange,
                        searchTerm: searchTerm,
                        inputRef: inputRef,
                        setIsSearchOpen: setIsSearchOpen,
                        testID: testID,
                        searchInputAccessibilityLabel: searchInputAccessibilityLabel,
                        clearButtonAccessibilityLabel: clearButtonAccessibilityLabel,
                        openFlyoutAccessibilityLabel: openFlyoutAccessibilityLabel,
                        isRtl: isRtl,
                        breakpoints: breakpoints,
                        isSearchOpen: isSearchOpen,
                        onSearch: onSearch,
                        isFiltersOpen: isFiltersOpen,
                        hasFilters: !!children,
                        setIsFiltersOpen: setIsFiltersOpen,
                        children: children && isFiltersOpen ? _jsx("div", {
                            css: filtersContainerStyles,
                            children: children(function() {
                                setIsFiltersOpen(false);
                                setIsSearchOpen(false);
                            })
                        }) : null
                    })
                ]
            })
        ]
    });
};
export default Search;
